import { matchPath } from "react-router-dom";

import { usePathname } from "src/routes/hooks";

import type { NavItemBaseProps } from "./types";

function matchesItem(item: NavItemBaseProps, pathname: string): boolean {
  return (
    Boolean(matchPath({ path: item.path, end: false }, pathname)) ||
    Boolean(item.children?.some((child) => matchesItem(child, pathname)))
  );
}

// A menu can contain related pages whose URLs do not share a common prefix.
export function useActiveNavItem(item: NavItemBaseProps): boolean {
  const pathname = usePathname();
  return item.children
    ? matchesItem(item, pathname)
    : Boolean(matchPath({ path: item.path, end: true }, pathname));
}
